import { ListItem, ListItemButton, ListItemText, Stack } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

import { getTargetType } from 'components/attacks/utils/attack-configuration'
import { AttackTypeIcon } from 'components/common/AttackTypeIcon'
import GlyphIcon, { HeptagonGlyphIcon } from 'components/common/GlyphIcon'
import {
  getNextScheduled,
  NOTIFICATION_LEFT_PADDING
} from 'components/navigation/Notifications/utils'
import useMetadata from 'hooks/use-metadata'
import theme from 'theme'
import { ScheduledAttack } from 'types/api/schedules/active'

export const ScheduledAttackListItem: React.FC<{
  schedule: ScheduledAttack
}> = ({ schedule, ...rest }) => {
  const isKubernetes =
    // @ts-ignore TODO there is a rats nest of typing issues here because of the variability in the API between snake case and camel case
    getTargetType(schedule.attack_configuration) === 'Kubernetes'
  const IconWrapper = isKubernetes ? HeptagonGlyphIcon : GlyphIcon

  const commandType = schedule.command?.type ?? 'scenario'
  const { getAttackName } = useMetadata()

  return (
    <ListItem
      data-test-notification-item
      data-test-scheduled-attack
      disablePadding
      component="div"
      {...rest}
    >
      <ListItemButton dense component={Link} to="/schedules/attacks">
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          sx={{ pl: NOTIFICATION_LEFT_PADDING, width: '100%' }}
        >
          <IconWrapper css={{ marginRight: theme.space[3] }}>
            <AttackTypeIcon icon={commandType} />
          </IconWrapper>

          <ListItemText
            data-test-notification-text
            primary={getAttackName(commandType)}
            secondary={getNextScheduled(schedule.trigger)}
          />
        </Stack>
      </ListItemButton>
    </ListItem>
  )
}
